import React from 'react';
import { createComponentPreviewEntry } from '@wix/editor-elements-integrations';
import {
  withScrollAPIForResponsiveContainer,
  ScrollableContainerTypes,
} from '@wix/editor-elements-preview-utils';
import { withComponentPreview as withMediaContainerPreviewWrapper } from '../../../MediaContainers/MediaContainer/viewer/MediaContainer.previewWrapper';

export default (
  ViewerComponent: React.ComponentType<ScrollableContainerTypes>,
) =>
  createComponentPreviewEntry(
    withScrollAPIForResponsiveContainer(
      withMediaContainerPreviewWrapper(ViewerComponent),
    ),
  );
